import { hopplerApi } from '../../constants/api';
import Axios from 'axios';
import { ListResponse, Listing, User } from '../../types';
import { ListingFilter } from '../../types/listing-filter.model';

export interface ListingParams {
  stage?: string;
  groupProfile?: string;
  filters?: ListingFilter
}

export interface ListingResponse extends ListResponse<Listing> {
  avePricePerSqm?: number;
  aveAreaSqm?: number;
  avePrice?: number;
}

export class ListingService {
  async getByKey(key: string) {
    const response = await Axios.get<Listing>(`${hopplerApi.host}/client/listing/${key.toLowerCase()}`);
    return response.data;
  }

  getListings(params: ListingParams) {
    let path: string;

    if (params.groupProfile) {
      path = `${hopplerApi.host}/kumita/groups/${params.groupProfile}/listings/${params.stage}`;
    } else {
      path = `${hopplerApi.host}/kumita/partner-broker/dashboard/listing/${params.stage}`;
    }

    return Axios.get<ListingResponse>(path, {
      params: params.filters,
      withCredentials: true
    });
  }

  getOtherUserUploadChoices(search, otherParams?: any) {
    otherParams = otherParams || {};

    return Axios.get<ListResponse<User>>(
      `${hopplerApi.host}/kumita/listing/upload-for`,
      {
        params: { search, ...otherParams },
        withCredentials: true
      }
    );
  }
}

export const listingService = new ListingService();
